import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_topic_event_RowClass, bl_cms_topic_ext_RowClass, bl_cms_topic_hdr_RowClass} from '../../../dbschema';

export class TopicContainerModel extends BaseContainerModel {
  bl_cms_topic_hdr: bl_cms_topic_hdr_RowClass = new bl_cms_topic_hdr_RowClass();
  bl_cms_topic_exts: bl_cms_topic_ext_RowClass [] = [];
  bl_cms_topic_events: bl_cms_topic_event_RowClass [] = [];
}
